import { render, staticRenderFns } from "./ItemCardDefaultSlider.vue?vue&type=template&id=ceb733ea&"
import script from "./ItemCardDefaultSlider.vue?vue&type=script&lang=js&"
export * from "./ItemCardDefaultSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports